<template>
  <div class="business-info-tab">
    <div style="overflow: auto">
      <div class="section">
        <div class="content has-text-left">
          <p class="field-name">
            Business Name
            <i class="is-pulled-right" @click="checkShareLink"> Share Link </i>
          </p>
          <div @click="editBusinessName">
            <i class="fa fa-signature" />&nbsp;&nbsp;
            <span>{{ business.name }}</span>
            <!-- <i :class="editIcon" @click="editBusinessName" /> -->
          </div>

          <hr class="hr-mb" />
          <p class="field-name">Business Type</p>
          <div @click="showSelect = !showSelect">
            <i class="fa fa-store-alt"></i>&nbsp;&nbsp;
            <span v-show="!showSelect">{{ business.business_type }}</span>
            <!-- <i :class="editIcon" @click="showSelect = !showSelect" /> -->
          </div>
          <div class="select" v-if="showSelect">
            <select @change="editBusinessType($event)">
              <option v-for="t in $store.state.businessTypes" :key="t">
                {{ t }}
              </option>
            </select>
          </div>

          <hr class="hr-mb" />
          <p class="field-name">
            Address
            <span class="is-pulled-right">
              Country:
              <span class="has-text-weight-bold is-uppercase">{{
                business.country
              }}</span>
            </span>
          </p>
          <div @click="editLocation">
            <i class="fa fa-map-marker-alt" />
            &nbsp;&nbsp;
            <span>{{ business.address }}</span>
            <!-- <i :class="editIcon" @click="editLocation" /> -->
          </div>
          <hr class="hr-mb" />

          <p class="field-name">Hours</p>
          <i class="far fa-clock" />&nbsp;&nbsp;
          <span class="button is-small is-rounded" :class="{ 'is-info': hoursType === 'always-open' }"
            @click="setHoursType('always-open')">Always open</span>&nbsp;
          <span class="button is-small is-rounded" :class="{ 'is-info': hoursType === 'selected-hours' }"
            @click="setHoursType('selected-hours')">Selected hours</span>
          <!-- <i :class="editIcon" @click="toggleEditHours" /> -->
          <hr />
          <div v-if="editHours">
            <div class="field has-addons" v-for="d in days" :key="d" style="margin-bottom: 0">
              <p class="control" style="margin-bottom: 0" @click="propagateHours(d)">
                <a class="button is-static" :class="{ 'has-text-danger': !hours[d] }" style="width: 80px">{{
                  capitaliseFirstLetter(d) }}</a>
              </p>
              <p class="control is-expanded">
                <input class="input" type="text" v-model="hours[d]" placeholder="1100-1400, 1600-2000" />
              </p>
            </div>
            <p style="padding-top: 4px">
              <i style="font-size: 0.85em">Leave blank if closed that day</i>
              <span class="button is-small is-rounded is-pulled-right is-success" @click="saveHours">Save</span>
            </p>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="content has-text-left">
          <p class="field-name">
            Phone Number
            <i v-if="phoneNumber" class="is-pulled-right" @click="editBusinessData('boss_phone_number')">
              {{ bossPhoneNumber || "Boss phone number?" }}
            </i>
          </p>
          <div @click="editBusinessData('phone_number')">
            <i class="fa fa-phone" />&nbsp;&nbsp;
            <span>{{ phoneNumber }}</span>
            <!-- <i :class="editIcon" @click="editBusinessData('phone_number')" /> -->
          </div>

          <hr class="hr-mb" />
          <p class="field-name">
            Email
            <i v-if="email" class="is-pulled-right" @click="editBusinessData('billing_email')">
              {{ billingEmail || "Billing email?" }}
            </i>
          </p>
          <div @click="editBusinessData('email')">
            <i class="far fa-envelope" />&nbsp;&nbsp;
            <span>{{ email }}</span>
            <!-- <i :class="editIcon" @click="editBusinessData('email')" /> -->
          </div>

          <hr class="hr-mb" />
          <p class="field-name">Website</p>
          <div @click="editBusinessData('website', true)">
            <i class="fa fa-globe" />&nbsp;&nbsp;
            <span @click="openWebsite">{{ website }}</span>
            <!-- <i :class="editIcon" @click="editBusinessData('website', true)" /> -->
          </div>

          <hr class="hr-mb" />
          <p class="field-name">
            Premium Link
            <i class="is-pulled-right" @click="updateNormalLink">
              {{ normalLink || "Normal Link?" }}
            </i>
          </p>
          <div @click="editBusinessData('premium_link')">
            <i class="fa fa-hand-holding-usd" />&nbsp;&nbsp;
            <span class="has-text-link">{{ premiumLink }}</span>
            <!-- <span class="is-pulled-right">
            <i :class="editIcon" @click="editBusinessData('premium_link')" />
          </span> -->
          </div>
          <hr />
        </div>
      </div>

      <div class="section">
        <div class="content has-text-left">
          <!-- Japanese | Fish | Wholesale | Sushi | Oysters | Cockles -->
          <p class="field-name">Categories</p>
          <div @click="editBusinessData('categories', true)">
            <i class="fa fa-cat" />&nbsp;&nbsp;
            <!-- <span>{{ categories }}</span> -->
            <span v-for="c in categoriesArray" :key="c" class="tag" :class="c.startsWith('_') ? 'is-danger' : 'is-link'"
              style="margin-right: 4px">
              {{ c }}
            </span>
            <!-- <i :class="editIcon" @click="editBusinessData('categories', true)" /> -->
          </div>

          <hr class="hr-mb" />
          <p class="field-name">Blurb</p>
          <div @click="editBusinessData('blurb', true)">
            <i class="fa fa-paragraph" />&nbsp;&nbsp;
            <span>{{ blurb }}</span>
            <!-- <i :class="editIcon" @click="editBusinessData('blurb', true)" /> -->
          </div>

          <hr class="hr-mb" />
          <p class="field-name">Quotes</p>
          <div @click="editBusinessData('quotes', true)">
            <i class="fa fa-quote-left" />&nbsp;&nbsp;
            <span>{{ quotes }}</span>
            <!-- <i :class="editIcon" @click="editBusinessData('quotes', true)" /> -->
          </div>

          <hr class="hr-mb" />
          <p class="field-name">Review Sites</p>
          <div @click="editBusinessData('review_sites', true)">
            <i class="fab fa-tripadvisor" />&nbsp;&nbsp;
            <span>{{ reviewSites }}</span>
            <!-- <i
            :class="editIcon"
            @click="editBusinessData('review_sites', true)"
          /> -->
          </div>

          <hr />
        </div>
      </div>

      <div class="section">
        <div class="content has-text-left">
          <p class="field-name">Price Info</p>
          <div @click="editBusinessData('price_info', true)">
            <i class="fa fa-list" />&nbsp;&nbsp;
            <span>{{ priceInfo }}</span>
            <!-- <i
              :class="editIcon"
              @click="editBusinessData('price_info', true)"
            /> -->
          </div>

          <hr class="hr-mb" />
          <p class="field-name">Service Radius</p>
          <div @click="editBusinessData('service_radius')">
            <i class="fa fa-drafting-compass" />&nbsp;&nbsp;
            <span>{{ serviceRadius }}</span>
            <!-- <i :class="editIcon" @click="editBusinessData('service_radius')" /> -->
          </div>

          <hr />
        </div>
      </div>

      <br />
    </div>
    <div style="padding: 0 10px; margin-bottom: 22px; text-align: left">
      <a class="button is-small is-white is-rounded" @click="toggleHidden">
        <i v-if="isHidden" class="far fa-eye-slash fa-2x has-text-danger" />
        <i v-else class="far fa-eye fa-2x has-text-success" /> </a>&nbsp;
      <a class="button is-small is-rounded" :class="{ 'is-link': isAward }" @click="toggleAward">
        <i class="fa fa-certificate fa-lg" />
      </a>
      <span class="is-pulled-right">
        <a class="button is-dark is-small is-rounded" @click="replicateBusiness" v-if="isSuperUser()">
          <i class="fa fa-clone fa-lg" /> </a>&nbsp;
        <a class="button is-danger is-small is-rounded" @click="deleteBusiness" v-if="isSuperUser()">
          <i class="fa fa-bomb fa-lg" />
        </a>
      </span>
    </div>

    <SetLocationMapModal @setLocation="setLocation" />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import SetLocationMapModal from "@/components/SetLocationMapModal.vue";

export default {
  name: "BusinessInfoTab",
  data() {
    return {
      z: 0,
      businessType: null,
      showSelect: false,
      editHours: false,
      days: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
      hours: null, // set on mounted
      hoursType: null,
    };
  },
  components: { SetLocationMapModal },
  computed: {
    editIcon() {
      return `fa fa-pencil-alt fa-sm is-pulled-right has-text-info`;
    },
    business() {
      this.console(`z ${this.z}`); // force update business
      return this.$store.state.selectedBusiness;
    },
    phoneNumber() {
      return this.business.data.phone_number;
    },
    bossPhoneNumber() {
      return this.business.data.boss_phone_number;
    },
    email() {
      return this.business.data.email;
    },
    billingEmail() {
      return this.business.data.billing_email;
    },
    website() {
      return this.business.data.website;
    },
    categories() {
      return this.business.data.categories;
    },
    categoriesArray() {
      if (!this.categories) return [];
      // var nospace = this.categories.replaceAll(", ", ",");
      var nospace = this.categories.replace(/, /g, ",");
      return nospace.split(",");
    },
    blurb() {
      return this.business.data.blurb;
    },
    quotes() {
      return this.business.data.quotes;
    },
    reviewSites() {
      return this.business.data.review_sites;
    },
    premiumLink() {
      return this.business.data.premium_link || "not set";
    },
    normalLink() {
      return this.business.data.normal_link;
    },
    priceInfo() {
      return this.business.data.price_info;
    },
    isHidden() {
      return this.business.data.hidden;
    },
    isAward() {
      return this.business.data.award;
    },
    serviceRadius() {
      return this.business.data.service_radius;
    },
  },
  mounted() {
    EventBus.$on("CHECK_SHARE_LINK", () => this.checkShareLink());
    this.init();
  },
  //   activated() {
  // this.init();
  //   },
  methods: {
    init() {
      if (!this.business) return alert("business not set"); // shouldn't hit this unless loading page directly
      // check if this.business.data.hours exists, else init
      this.hoursType = this.business.data.hours_type;
      if (this.business.data.hours) {
        this.hours = this.business.data.hours;
      } else {
        this.hours = {
          mon: null,
          tue: null,
          wed: null,
          thu: null,
          fri: null,
          sat: null,
          sun: null,
        };
      }
      this.z += 1;
    },
    propagateHours(d) {
      var dow = this.capitaliseFirstLetter(d);
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='far fa-clock'></i>&nbsp;Propagate Hours
        </p>
        <p style='margin-bottom:10px'>Copy these hours to all days of the week?</p>
        <p style='font-weight:550; opacity:0.8'> 
          <i>${dow}: ${this.hours[d] || "Closed"}</i> 
        </p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Propagate",
      }).then((val) => {
        if (!val.value) return;
        for (const key in this.hours) {
          this.hours[key] = this.hours[d];
        }
      });
    },
    checkShareLink(force) {
      if (this.normalLink || force) return this.showShareLinks();
      this.setNormalLink();
    },
    showShareLinks() {
      var premium = this.premiumLink || "(Not yet set)";
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='fa fa-share-alt'></i>&nbsp;Direct Share Links
        </p>
        <p style='margin-bottom:10px'>
          Usage: <a>tukapp.co/${this.normalLink}</a>
        </p>
        <p style='margin-bottom:10px'>
          Normal link: <strong><a href='${this.normalLink}' target='_blank'>${this.normalLink}</a></strong>
        </p>
        <p>
          Premium link: <strong><a href='${premium}' target='_blank'>${premium}</a></strong>
        </p>
        </div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    setHoursType(type) {
      if (type === "always-open") {
        if (this.hoursType === "always-open") {
          this.infoToast("Already set as `Always open`");
          return;
        } else {
          this.editHours = false;
          this.hoursType = type;
          this.saveHours();
        }
      } else {
        this.hoursType = type;
        this.editHours = true;
      }

      // if (type === "selected-hours") {
      //   // this.toggleEditHours();

      //   return;
      // } else {
      //   this.editHours = false;
      // }
      // if (this.hoursType === "always-open") {
      // } else {
      //   this.saveHours();
      // }
    },
    toggleEditHours() {
      if (this.editHours) this.saveHours();
      this.editHours = !this.editHours;
    },
    saveHours() {
      this.editHours = false;
      var obj = this.business.data || {};
      obj.hours = this.hours;
      obj.hours_type = this.hoursType;
      console.log("saveHours", obj);
      var loader = this.loadingDots("gold");
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.console("updateBusiness success", res);
          this.business.data = obj;
          this.z += 1;
          this.successToast("Saved!");
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    toggleHidden() {
      var obj = this.business.data || {};
      obj.hidden = !obj.hidden;
      var loader = this.loadingDots("red");
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.console("updateBusiness success", res);
          this.business.data = obj;
          this.z += 1;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    toggleAward() {
      var obj = this.business.data || {};
      obj.award = !obj.award;
      var loader = this.loadingDots("blue");
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.console("updateBusiness success", res);
          this.business.data = obj;
          this.z += 1;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    openWebsite() {
      window.open(this.website, "_blank");
    },
    dayOfWeek(i) {
      return this.days[i];
    },
    editBusinessName() {
      this.$swal({
        title: `Edit Business Name`,
        input: "text",
        inputValue: this.business.name,
        showCancelButton: false,
        showCloseButton: true,
        inputValidator: (txt) => {
          if (!txt) return "Enter a name";
        },
      }).then((val) => {
        if (!val.value) return;
        var obj = { id: this.business.id, name: val.value };
        this.$store
          .dispatch("updateBusiness", obj)
          .then((res) => {
            this.console("updateBusiness success", res);
            // this.success(); // successModal mixin
            this.successToast("Updated!");
            this.business.name = val.value; // set it locally
          })
          .catch((err) => this.apiError(err));
      });
    },
    editBusinessType(e) {
      this.showSelect = false; // hide select
      var loader = this.loadingDots("purple");
      var obj = { id: this.business.id, business_type: e.target.value };
      this.$store
        .dispatch("updateBusiness", obj)
        .then((res) => {
          this.console("updateBusiness success", res);
          this.successToast("Updated!"); // successModal mixin
          this.business.business_type = e.target.value; // set it locally
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    addPic(picType) {
      this.$swal({
        title: `Paste URL for ${picType}`,
        input: "text",
        showCancelButton: false,
        inputValidator: (txt) => {
          if (!txt) return "Enter a URL";
        },
      }).then((val) => {
        if (!val.value) return;
        var obj = { id: this.$store.state.selectedBusiness.id };
        obj[picType] = val.value;
        this.$store
          .dispatch("updateBusiness", obj)
          .then((res) => {
            this.console("updateBusiness success", res);
            this.success(); // successModal mixin
            this.business[picType] = val.value;
          })
          .catch((err) => this.apiError(err));
      });
    },
    replicateBusiness() {
      this.$swal({
        html: `<div style=' text-align:left'>
        <p style='font-size:1.2em'><i class='fa fa-copy has-text-grey'></i>&nbsp;Replicate this business?</p>
        <p style='margin-top:10px'>This will replicate the business and the workflows.</p>
        </div>`,
        input: "number",
        inputPlaceholder: "Passcode",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: "gold",
        cancelButtonColor: "lightgrey",
        cancelButtonText: "Cancel",
        confirmButtonText: "Yes 🐣",
        inputValidator: (val) => {
          if (val !== "82801460") return "Incorrect Passcode";
        },
      }).then((val) => {
        if (!val.value) return; // cancelled or closed
        var loader = this.loadingDots("gold");
        this.$store
          .dispatch("replicateBusiness", this.$store.state.selectedBusiness.id)
          .then((res) => {
            this.console("replicateBusiness success", res);
            // this.success(); // successModal mixin
            this.replicateWorkflows(res.data.id);
          })
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    replicateWorkflows(newBusinessID) {
      var payload = {
        old: this.$store.state.selectedBusiness.id,
        new: newBusinessID,
      };
      var loader = this.loadingDots("green");
      this.$store
        .dispatch("replicateWorkflows", payload)
        .then((res) => {
          this.console("replicateWorkflows success", res);
          var msg = `Successfully replicated the<br>business and its workflows!`;
          this.successToast(msg, "top");
          setTimeout(() => {
            this.goto("/business_profile/" + newBusinessID);
            this.refreshPage();
          }, 500);
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    deleteBusiness() {
      this.$swal({
        title: "<div style='font-size:1.5em'>💣</div>",
        html: "<div style='font-size:1.5em'>Soft delete this business?</div>",
        input: "number",
        inputPlaceholder: "Passcode",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: this.bulmaColor("danger"),
        cancelButtonColor: this.bulmaColor("success"),
        cancelButtonText: "Do Not Delete",
        confirmButtonText: "Yes 💣",
        inputValidator: (val) => {
          if (val !== "82801460") return "Incorrect Passcode";
        },
      }).then((val) => {
        console.log("deleteBusiness", val);
        if (val.value) {
          this.$store
            .dispatch("deleteBusiness", this.$store.state.selectedBusiness.id)
            .then((res) => {
              this.console("deleteBusiness success", res);
              this.success(); // successModal mixin
            })
            .catch((err) => this.apiError(err));
          // probably should .finally(() => this.goHome()); or go back to shoplist
        }
      });
    },
    parsePhone(s) {
      // assume a + country code is correct, just remove any white spaces
      if (s[0] === "+") return s.replace(/\s+/g, "");
      // assume starting with 0 means thai number
      if (s[0] === "0") return "+66" + s.substring(1).replace(/\s+/g, "");
      // otherwise invalid
      return null;
    },
    editBusinessData(fieldName, isTextArea) {
      var help = null;
      if (fieldName === "review_sites")
        help = `Comma-separated list of review site links<br>', ' comma+space required`;
      if (fieldName === "quotes") help = `Separate quotes with &lt;br> tag`;
      if (fieldName === "categories")
        help = `Comma-separated list of category tags.<br>The first one should be the main category.<br>Hidden tags start with underscore, e.g. _promo`;
      if (fieldName === "service_radius") help = `Service radius in kilometers`;
      if (fieldName === "price_info")
        help = `Price info for services (short list), separate line items with a return`;
      if (fieldName === "premium_link")
        help = `Premium links should start with @ symbol and be lowercase`;
      var inputType = "text";
      if (isTextArea) inputType = "textarea";
      this.$swal({
        title: `Edit ${fieldName}`,
        html: help ? `<div style='text-align:left'>${help}</div>` : null,
        input: inputType,
        inputValue: this.business.data[fieldName] || "",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: this.$t("save"),
        cancelButtonText: `Clear&nbsp;<i class='fa fa-bomb'></i>`,
        cancelButtonColor: this.bulmaColor("danger"),
        inputValidator: (txt) => {
          if (!txt) return `Enter ${fieldName}`;
          // valid so dispatch
          if (txt === "null" || txt === "na") txt = null;
          // parse phone number
          if (fieldName === "phone_number") {
            txt = this.parsePhone(txt);
            if (!txt) return "Invalid phone number";
          }
          if (fieldName === "premium_link" && txt[0] !== "@") {
            txt = "@" + txt;
          }
          var obj = this.business.data || {};
          obj[fieldName] = txt;
          var loader = this.loadingDots("gold");
          this.$store
            .dispatch("updateBusiness", {
              id: this.business.id,
              data: obj,
            })
            .then((res) => {
              this.console("updateBusiness success", res);
              // this.success(); // successModal mixin
              this.business.data = obj;
              this.z += 1;
              if (fieldName === "premium_link") this.setPremiumLink(txt);
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        },
      }).then((val) => {
        if (val.dismiss === "cancel") {
          console.log(`clear field ${fieldName}`);
          var obj = this.business.data || {};
          obj[fieldName] = null;
          var loader = this.loadingDots("red");
          this.$store
            .dispatch("updateBusiness", {
              id: this.business.id,
              data: obj,
            })
            .then(() => {
              this.business.data = obj;
              this.z += 1;
              this.errorToast("Cleared");
            })
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    setPremiumLink(txt) {
      if (!txt || txt[0] !== "@") {
        return this.warningAlert("premium_link must start with @ symbol"); // shouldn't happen anymore
      }
      var longShopURL = `/shop/${this.business.id}`;
      var shortLinkID = txt;
      var validity = 60 * 24 * 365; // valid for 1 year
      this.shortenLink(longShopURL, shortLinkID, validity);
    },
    setNormalLink() {
      var longShopURL = `/shop/${this.business.id}`;
      var shortLinkID = "~" + this.randomSixChars();
      var validity = 60 * 24 * 365 * 100; // valid for 100 years
      this.shortenLink(longShopURL, shortLinkID, validity); // should check for clash

      var obj = this.business.data || {};
      obj.normal_link = shortLinkID;
      var loader = this.loadingDots("gold");
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then((res) => {
          this.console("updateBusiness success", res);
          this.business.data = obj;
          this.z += 1;
          this.$nextTick(() => this.checkShareLink(true));
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    updateNormalLink() {
      this.$swal({
        title: "Update normal_link?",
        text: this.normalLink,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Update",
      }).then((val) => {
        if (val.value) this.setNormalLink();
      });
    },
    randomSixChars() {
      return (
        Math.random().toString(36).substring(2, 5) +
        Math.random().toString(36).substring(2, 5)
      );
    },
    editLocation() {
      console.log("editLocation", this.$store.state.selectedBusiness);
      this.displayModal(".set-location-map-modal");
      EventBus.$emit("SET_LOCATION_MAP", this.$store.state.selectedBusiness);
    },
    setLocation(coords) {
      console.log("setLocation", coords);
      // this.commit("updateBusinessCoords", coords); // better to use mutation
      (this.$store.state.selectedBusiness.lat = coords.lat),
        (this.$store.state.selectedBusiness.lon = coords.lng),
        this.$store
          .dispatch("updateBusiness", {
            id: this.$store.state.selectedBusiness.id,
            lat: coords.lat,
            lon: coords.lng,
          })
          .then((res) => this.successToast("Updated business location!", "top"))
          .catch((err) => this.apiError(err));
    },
  },
};
</script>

<style scoped>
hr {
  margin: 0 0;
}

.field-name {
  margin-bottom: 0;
  line-height: 0pt;
  font-size: 0.8em;
  opacity: 0.6;
}

.card {
  margin-top: 10px;
}

.short {
  height: 70px;
  overflow: hidden;
}

.card-content {
  /* padding-bottom: 16px; */
  padding: 16px 12px;
}

.icon {
  padding: 12px;
  /* border-radius: 50%; */
  /* border: 1px solid rgba(128, 128, 128, 0.08);
  box-shadow: 0 0 1px rgba(128, 128, 128, 0.05); */
}

.content .fa,
.content .far {
  color: #999;
}

.hr-mb {
  margin-bottom: 16px;
}

.card-content span {
  overflow-wrap: anywhere;
}

.fa-pencil-alt {
  opacity: 0.6;
}

.field-name i {
  font-weight: 500;
}

.section {
  text-align: left;
  background-color: white;
  padding: 16px 12px;
  margin-top: 10px;
}
</style>